<template>
  <div>
    <button class="btn btn-edit" @click="openModal"><img src="@/assets/images/admin/cashpayments/edit.png" alt="Edit" style="width: 25px; height: 25px;" />
</button>

    <div class="modal fade" ref="editMemberModal" tabindex="-1" role="dialog" aria-labelledby="editMemberModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Edit staff member</h4>
            <button type="button" class="close" @click="hideModal" aria-label="Close">
              <span aria-hidden="true">X</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row d-flex align-items-stretch">
              <div class="col-md-6 d-flex">
                <div class="card flex-grow-1">
                  <div class="card-body">
                    <div class="form-group">
                      <h5 class="section-title">Contract details</h5>
                      <label for="first-name">First name</label>
                      <input type="text" id="first-name" class="form-control" v-model="form.first_name" />
                    </div>
                    <div class="form-group">
                      <label for="last-name">Last name</label>
                      <input type="text" id="last-name" class="form-control" v-model="form.last_name" />
                    </div>
                    <div class="form-group">
                      <label for="username">Username</label>
                      <input type="text" id="username" class="form-control" v-model="form.username" />
                    </div>
                    <div class="form-group">
                      <label for="password">Password</label>
                      <div class="input-group">
                        <input :type="passwordFieldType" id="password" class="form-control" v-model="form.password" />
                        <button class="btn btn-outline-primary" type="button" @click="togglePasswordVisibility">
                          <i :class="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" class="f-18"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 d-flex">
                <div class="card flex-grow-1">
                  <div class="card-body">
                    <div class="form-group">
                      <h5 class="section-title">Access</h5>
                      <label for="role">Role</label>
                      <select id="role" class="form-control" v-model="form.role_id">
                        <option value="" disabled>Select a role</option>
                        <option v-for="role in roleStore.roles" :key="role.id" :value="role.id">
                          {{ role.name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group mt-4">
                      <div class="ms-2 checkbox checkbox-success">
                        <input :id="`checkbox-edit-${form.id}`" type="checkbox" v-model="form.enabled">
                        <label :for="`checkbox-edit-${form.id}`">Enabled</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <button class="btn btn-green btn-ok me-1" @click="submitForm">Save</button>
                <button class="btn btn-cancel" @click="hideModal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import { Modal } from 'bootstrap';
import { useMemberStore } from '@/store/admin/member';
import { useRoleStore } from '@/store/admin/role';
import Swal from 'sweetalert2';

const props = defineProps({
  member: Object, // 接收父組件傳來的 member 資料
});

const memberStore = useMemberStore();
const roleStore = useRoleStore();

const form = ref({
  id: '',
  first_name: '',
  last_name: '',
  username: '',
  password: '',
  role_id: '',
  enabled: '',
});

const editMemberModal = ref(null);
let modalInstance = null;

// 密碼顯示與隱藏控制
const passwordFieldType = ref('password');
const togglePasswordVisibility = () => {
  passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password';
};

const openModal = () => {
  // 將傳入的 member 資料綁定到 form 中，並將 enabled 正確轉換為布爾值
  form.value = { 
    ...props.member,
    enabled: props.member.enabled === 1, // 確保 '1' 轉換為 true，'0' 轉換為 false
  };

  if (!modalInstance) {
    modalInstance = new Modal(editMemberModal.value);
  }
  modalInstance.show();
};

const hideModal = () => {
  if (modalInstance) {
    modalInstance.hide();
  }
};

const submitForm = () => {
  const updatedForm = {
    ...form.value,
    enabled: form.value.enabled ? 1 : 0, // 在提交時將布爾值轉換為 '1' 或 '0'
  };

  memberStore.updateMember(updatedForm)
    .then(() => {
      hideModal();
    })
    .catch(error => {
      console.error('Error updating member:', error);
    });
};

// 在組件掛載時獲取角色列表
onMounted(async () => {
  await roleStore.fetchRoles();
});
</script>

<style scoped>
label {
  font-size: 16px;
  margin-top: 5px;
}

.btn-green {
  background: rgba(0, 201, 98, 1);
  color: black;
  border: none;
  width: 244.83px;
  height: 46px;
  border-radius: 30px;
  padding: 10px, 32px, 10px, 32px;
}

.btn-edit{
  color: #8476f5;
}

.btn-green:hover {
  background-color: #00b452;
}

.btn-ok {
  width: 150px;
}

.btn-cancel {
  background-color: #fff;
  color: #8476f4;
  border: 2px solid #8476f4;
  border-radius: 30px;
  width: 150px;
  height: 46px;
  padding: 14px 32px 14px 32px;
}

.btn-cancel:hover {
  background-color: #e6e6ff;
}

.modal-content {
  border-radius: 10px;
  padding: 20px;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header {
  border-bottom: 1px solid #dee2e6;
  font-weight: bold;
  background-color: #d9dde3;
}

.card {
  background-color: #d9dde3;
}

.close {
  color: #333;
  opacity: 1;
  font-size: 20px;
  padding: 0;
  background: none;
  border: none;
}

.close:hover {
  color: #000;
}

.row.d-flex {
  display: flex;
}

.col-md-6.d-flex {
  display: flex;
  flex-direction: column;
}

.card.flex-grow-1 {
  flex-grow: 1;
}

.align-items-stretch {
  align-items: stretch;
}

.text-danger {
  color: red;
  font-size: 0.9em;
}
</style>
